export default class DateHelper {
    static isAdult(birthday: Date): boolean {
        const eighteenthBirthday = new Date(birthday.getFullYear()+18, birthday.getMonth(), birthday.getDate());
        return eighteenthBirthday <= new Date();
    }


    static calculateAge(birthday: Date): number {
        var ageDifMs = Date.now() - birthday.getTime();
        // miliseconds from epoch
        var ageDate = new Date(ageDifMs); 
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }
}